import {useContext, useEffect, useState} from "react";
import {Modal} from "../components/Modal";
import {AccountContext} from "../context/AccountProvider";
import {sendAssistanceRequest} from "../service/accountApi";
import {toast} from "react-toastify";
import {t} from "i18next";

const Assistant = () => {
    const {account} = useContext(AccountContext);

    const [isOpen, setIsOpen] = useState(false);

    const [formData, setFormData] = useState({
        name: "",
        phoneNumber: "",
        email: "",
        description: "",
    });

    const [isSubmitButtonDisabled, setIsSubmitButtonDisabled] = useState(false);

    // Prefilling the form when the account data is available
    useEffect(() => {
        if (isOpen && account && Object.keys(account).length > 0) {
            setFormData({
                ...formData,
                name: account.firstName + " " + account.middleName + " " + (account.lastName ? account.lastName : '') || "",
                phoneNumber: `${account.phone.dialingCode}-${account.phone.number}` || "",
                email: account.email || "",
            });
        }
    }, [isOpen]);

    // Handle input change
    const handleChange = (e) => {
        const {name, value} = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleClose = () => {
        setIsOpen(false);
        setTimeout(() => {
            setFormData({
                name: "",
                phoneNumber: "",
                email: "",
                description: "",
            })
        }, 200);
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log("Form Submitted:", formData);
        setIsSubmitButtonDisabled(true);

        sendAssistanceRequest(formData)
            .then((response) => {
                console.log("Send Assistance Request Response:", response);
                if (response && response.success) {
                    toast.dismiss();
                    toast.success(t("ASSISTANCE_FORM.REQUEST.SUCCESS"), {
                        autoClose: 30000,
                        closeOnClick: false,
                        className: "portrait:w-full landscape:w-[25vw]"
                    });
                    handleClose();
                    setIsSubmitButtonDisabled(false);
                } else {
                    toast.dismiss();
                    toast.error(t("ASSISTANCE_FORM.REQUEST.ERROR"));
                    setIsSubmitButtonDisabled(false);
                }
            })
            .catch((error) => {
                console.log("Error sending assistance request:", error);
                toast.dismiss();
                toast.error(t("ASSISTANCE_FORM.REQUEST.ERROR"));
                setIsSubmitButtonDisabled(false);
            });
    };

    return (
        <>
            {/* Floating Assistance Button */}
            <div className="fixed md:bottom-5 md:right-5 bottom-0 right-0 z-50">
                <button
                    onClick={() => setIsOpen(true)}
                    className="bg-blue-500 text-white rounded-full shadow-lg px-5 py-3 text-sm font-medium transition-all hover:bg-blue-600"
                >
                    🆘 Assistance
                </button>
            </div>

            {/* Assistance Modal */}
            <Modal isOpen={isOpen} zIndex="z-[200]">
                <div
                    className="bg-white shadow-xl rounded-lg p-6 w-[100%] max-w-md border border-gray-200"
                    onClick={(e) => e.stopPropagation()}
                >
                    {/* Header with Close Button */}
                    <div className="flex items-center justify-between mb-3">
                        <h2 className="text-lg font-semibold">Need Assistance?</h2>
                        <button
                            type="button"
                            onClick={handleClose}
                            className="p-2 rounded-full hover:bg-gray-100 transition"
                            aria-label="Close Modal"
                        >
                            <img
                                className="w-6 h-6"
                                src="/assets/close-icon.png"
                                alt="Close"
                                title="Close"
                            />
                        </button>
                    </div>

                    {/* Assistance Form */}
                    <form onSubmit={handleSubmit} className="flex flex-col gap-3">
                        <input
                            name="name"
                            placeholder="Name"
                            value={formData.name}
                            onChange={handleChange}
                            disabled={!!account?.firstName}
                            required={!account?.firstName}
                            className="border rounded p-2 w-full"
                        />
                        <input
                            type="tel"
                            name="phoneNumber"
                            placeholder="Phone Number"
                            value={formData.phoneNumber}
                            onChange={handleChange}
                            disabled={!!account?.phone?.number}
                            required={!account?.phone?.number}
                            className="border rounded p-2 w-full"
                        />
                        <input
                            type="email"
                            name="email"
                            placeholder="Email ID"
                            value={formData.email}
                            onChange={handleChange}
                            disabled={!!account?.email}
                            required={!account?.email}
                            className="border rounded p-2 w-full"
                        />
                        <textarea
                            name="description"
                            placeholder="Describe your issue..."
                            value={formData.description}
                            onChange={handleChange}
                            required
                            className="border rounded p-2 w-full h-24"
                        />
                        <button
                            disabled={isSubmitButtonDisabled}
                            type="submit"
                            className="bg-blue-500 text-white rounded p-2 hover:bg-blue-600 transition disabled:bg-slate-500"
                        >
                            Submit
                        </button>
                    </form>
                </div>
            </Modal>
        </>
    );
}
export default Assistant
